import React from 'react';
import RenderExistingFileV2 from '../../../renderExistingFile';
import Drawer from '../../../customDrawer';
import { FolderRight } from '../styles';
import { useMessageFeedEnvironment, useFileSelection } from '../MessageFeedContext';
import { RawProjectFile } from '../../../../mobx/interfaces/project';
import { useMobileDevice } from '../../../../global/useMobile';

interface MessageFileDrawerProps {
  onSelectFile: (item: RawProjectFile) => void;
  isCommentModal: boolean;
}

const MessageFileDrawer: React.FC<MessageFileDrawerProps> = ({ onSelectFile, isCommentModal }) => {
  const { isNavbarMessage, isProjectMessageDetail } = useMessageFeedEnvironment();
  const { attachment, setAttachment, selectFile, setSelectFile } = useFileSelection();
  const mobile = useMobileDevice();

  if (selectFile) {
    return null;
  }

  return (
    <>
      {!mobile && attachment && !isCommentModal && (
        <FolderRight>
          <RenderExistingFileV2
            setAttachment={() => setAttachment(false)}
            setSelectFile={(value: boolean) => setSelectFile(value)}
            onSelectFile={onSelectFile}
            isMessage={isNavbarMessage}
            isProjectMessageDetail={isProjectMessageDetail}
          />
        </FolderRight>
      )}
      <Drawer
        placement='right'
        onClose={() => setAttachment(false)}
        open={!!attachment && !!isCommentModal}
        width='350px'>
        {attachment && isCommentModal && (
          <RenderExistingFileV2
            setAttachment={() => setAttachment(false)}
            onSelectFile={onSelectFile}
            setSelectFile={(value: boolean) => setSelectFile(value)}
          />
        )}
      </Drawer>
    </>
  );
};

export default MessageFileDrawer;
